"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _mobx = require("mobx");

var _mobxReact = require("mobx-react");

var _Info = _interopRequireDefault(require("../Info"));

var _StringOrRender = _interopRequireDefault(require("../helper/StringOrRender"));

var _styling = require("../../toolkit/styling");

var _providers = require("../../toolkit/providers");

var _class, _class2, _class3, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var Field = (0, _mobxReact.observer)(_class = (_class2 = (_temp = _class3 = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(Field, _Component);

  var _super = _createSuper(Field);

  function Field() {
    var _this;

    (0, _classCallCheck2["default"])(this, Field);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.context = void 0;
    return _this;
  }

  (0, _createClass2["default"])(Field, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          renderRightSide = _this$props.renderRightSide,
          children = _this$props.children,
          className = _this$props.className,
          title = _this$props.title,
          style = _this$props.style,
          description = _this$props.description;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(this.styles.root, className, style)
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(this.styles.titleContainer)
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(this.styles.titleGroup)
      }, /*#__PURE__*/_react["default"].createElement("section", {
        className: (0, _styling.css)(this.styles.title)
      }, /*#__PURE__*/_react["default"].createElement(_StringOrRender["default"], {
        value: title
      })), description && /*#__PURE__*/_react["default"].createElement(_Info["default"], {
        className: (0, _styling.css)(this.styles.info),
        popoverContent: description,
        size: 14,
        position: "top center"
      })), renderRightSide && renderRightSide()), children);
    }
  }, {
    key: "styles",
    get: function get() {
      var _this$context$theming = this.context.theming,
          textDark = _this$context$theming.theme.textDark,
          fonts = _this$context$theming.fonts;
      return _aphrodite.StyleSheet.create({
        root: {
          display: "flex",
          flexDirection: "column"
        },
        titleContainer: {
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          justifyContent: "space-between",
          ":nth-child(1n) > *": {
            marginBottom: 5
          }
        },
        title: {
          fontSize: 15,
          color: textDark,
          fontFamily: fonts.regular,
          cursor: "default",
          overflow: "hidden",
          whiteSpace: "nowrap",
          textOverflow: "ellipsis"
        },
        titleGroup: {
          display: "flex",
          flexDirection: "row",
          alignItems: "center"
        },
        info: {
          marginTop: 2,
          marginLeft: 8
        }
      });
    }
  }]);
  return Field;
}(_react.Component), _class3.contextType = _providers.LegoContext, _class3.propDoc = {
  title: {
    required: true,
    type: "string",
    description: "Name of the field"
  },
  renderRightSide: {
    required: false,
    defaultValue: "null",
    type: "(() => ReactNode)",
    description: "Optional hook to render something on the opposite " + "side of the title. An example of this is " + "the \"Show/hide password\" button in" + " [`PasswordField`](/lego/component/PasswordField)"
  }
}, _class3.demoProps = {
  title: "First Name"
}, _class3.demoRender = "\n<Field title=\"First Name\">\n  <TextInput\n    placeholder=\"Create a name for your store\"\n    focusOnMount={true}\n    onChange={() => {}}\n    height={40}\n  />\n</Field>\n", _temp), ((0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "styles", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "styles"), _class2.prototype)), _class2)) || _class;

var _default = Field;
exports["default"] = _default;